import { Link } from "react-router-dom";
import {
  IdentificationBadge,
  HouseLine,
  Truck,
  Info,
  Books,
  ShieldCheck,
} from "@phosphor-icons/react";

const LINKS = [
  {
    to: "/visitors",
    title: "Visitors",
    desc: "Security pass, parking & navigation.",
    icon: IdentificationBadge,
  },
  {
    to: "/residents",
    title: "New Residents",
    desc: "Welcome kit, onboarding & utilities.",
    icon: HouseLine,
  },
  {
    to: "/relocation",
    title: "Relocation",
    desc: "Move-in, move-out and interior works.",
    icon: Truck,
  },
  {
    to: "/info",
    title: "Resident Info",
    desc: "Bills, EV chargers, office holidays.",
    icon: Info,
  },
  {
    to: "/library",
    title: "Aristotle Library",
    desc: "5,000+ titles, newspapers, magazines.",
    icon: Books,
  },
  {
    to: "/policies",
    title: "Policies",
    desc: "Dos, don'ts and codes of conduct.",
    icon: ShieldCheck,
  },
];

export const QuickLinks = () => (
  <section
    data-testid="quick-links-section"
    className="py-24 md:py-32 px-6 md:px-10 bg-brand-ivory"
  >
    <div className="max-w-7xl mx-auto">
      <div className="text-xs uppercase tracking-[0.28em] font-semibold text-brand-leaf mb-5 flex items-center gap-3">
        <span className="w-8 h-px bg-brand-gold" /> Quick Access
      </div>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-brand-forest leading-tight max-w-3xl mb-16">
        Everything you need,
        <br />
        <span className="italic text-brand-gold">a click away.</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {LINKS.map((l, i) => {
          const Icon = l.icon;
          return (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`quick-link-${l.title.toLowerCase().replace(/\s/g, "-")}`}
              className="group p-8 md:p-10 rounded-2xl border border-brand-sage bg-brand-sage/30 hover:bg-brand-forest hover:border-brand-forest hover:-translate-y-1 transition-all duration-500"
            >
              <Icon
                size={32}
                weight="light"
                className="text-brand-forest group-hover:text-brand-gold transition-colors"
              />
              <h3 className="font-display text-2xl md:text-3xl text-brand-forest group-hover:text-brand-ivory mt-6 transition-colors">
                {l.title}
              </h3>
              <p className="text-brand-mute group-hover:text-brand-ivory/75 mt-3 leading-relaxed transition-colors">
                {l.desc}
              </p>
              <div className="mt-6 text-sm font-medium text-brand-forest group-hover:text-brand-gold transition-colors">
                Explore →
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);
